export default __webpack_public_path__ + "static/media/84.6c59dbc6.png";